<template>
    <div style="width: 100%">
        <v-progress-linear indeterminate :active="isLoading" style="width: 100%"></v-progress-linear>
        <v-sheet height="64">
            <v-toolbar flat>
                <v-btn outlined class="mr-4 overline" color="grey darken-2" @click="setToday" :disabled="isLoading">
                    Hoy
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="prevMonth" :disabled="isLoading">
                    <v-icon small> mdi-chevron-left </v-icon>
                </v-btn>
                <v-toolbar-title class="font-weight-light primary--text" v-if="$refs.calendar">
                    {{
                    $refs.calendar.title.charAt(0).toUpperCase() +
                    $refs.calendar.title.slice(1)
                    }}
                </v-toolbar-title>
                <v-btn fab text small color="grey darken-2" @click="nextMonth" :disabled="isLoading">
                    <v-icon small> mdi-chevron-right </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn outlined class="mr-4" color="grey darken-2" v-if="selectedDay" @click="viewMonth()">
                    Volver
                </v-btn>
                <v-btn outlined class="mr-4 overline" color="grey darken-2"
                    v-if="$store.getters['login/hasManagerPermission']" @click="openMoveScheduled"
                    :disabled="isLoading">
                    Copiar Agendados
                </v-btn>
            </v-toolbar>
        </v-sheet>

        <v-row no-gutters>
            <v-select class="pa-4" :items="comerciales" v-model="selectedComercial" item-text="nombreCompleto"
                :disabled="isLoading" return-object prepend-inner-icon="mdi-account"
                hint="Selecciona un comercial para ver su calendario, por defecto se mostrara el de la cuenta logueada"
                persistent-hint :menu-props="{ maxHeight: '600' }" label="Comercial" clearable>
                <template #item="{ item }">
                    <v-row>
                        <v-col cols="11">
                            {{ item.nombreCompleto }}
                        </v-col>
                        <v-col v-if="item.estado && !$vuetify.breakpoint.smAndDown" cols="1">
                            <v-chip label :color="estadoComercial[item.estado]" medium
                                class="d-flex justify-center overline">
                                {{ item.estado }}
                            </v-chip>
                        </v-col>
                        <v-col v-if="item.estado && $vuetify.breakpoint.smAndDown" cols="1">
                            <v-icon :color="estadoComercial[item.estado]" large class="d-flex justify-center overline">
                                mdi-circle
                            </v-icon>
                        </v-col>
                    </v-row>
                </template>
            </v-select>
        </v-row>

        <v-window show-arrows>
            <v-window-item>
                <v-sheet height="690">
                    <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" locale="es-es"
                        :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay"
                        @click:date="viewDay" @change="setAgendados">
                        <template #event="event">
                            <span class="font-weight-bold mx-1">
                                {{event.eventParsed.start.time}}
                            </span>
                            <span :class="event.eventParsed.input.isAttended ? 'text-decoration-line-through' : ''">
                                {{event.eventParsed.input.name}}
                            </span>
                        </template>
                    </v-calendar>
                    <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement"
                        offset-x>
                        <v-card color="grey lighten-4" flat>
                            <v-toolbar :color="selectedEvent.color" dark flat>
                                <v-btn icon>
                                    <v-icon size="35">mdi-account</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="justify-center" v-html="selectedEvent.name"></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="
                                    showEditDialog(selectedEvent.cliente)
                                ">
                                    <v-icon size="35">mdi-pen</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <h2 class="display-1 font-weight-light" v-html="selectedEvent.details"></h2>
                            </v-card-text>
                            <v-card-actions class="d-flex">
                                <v-btn v-if="
                                    isSelectedComercialActual ||
                                    $store.getters[
                                        'login/hasAdminPermission'
                                    ]
                                " :loading="isLoadingUpdateAgendado" text @click="changeIsAttended(selectedEvent)">
                                    <v-icon class="mr-1" :color="
                                        selectedEvent.isAttended
                                            ? 'green'
                                            : 'red'
                                    ">mdi-circle</v-icon>
                                    {{
                                    selectedEvent.isAttended
                                    ? "Atendido"
                                    : "No Atendido"
                                    }}
                                </v-btn>
                                <v-btn text class="ml-auto" color="red" @click="selectedOpen = false">
                                    Atrás
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-sheet>
            </v-window-item>
            <v-window-item>
                <v-data-table :headers="headers" :items="events" :footer-props="footerProps">
                    <template v-slot:item.cliente.telefonos_contacto="{ item }">
                        <div class="d-flex justify-center">
                            <v-menu v-if="
                                item.cliente.telefonos_contacto.length > 1
                            " offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="primary" v-bind="attrs" v-on="on">
                                        mdi-phone-plus
                                    </v-icon>
                                </template>
                                <v-list>
                                    <v-list-item v-for="(tlf, index) in item.cliente
                                    .telefonos_contacto" :key="index">
                                        <v-list-item-title>{{
                                        tlf
                                        }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <div v-else>
                                {{ item.cliente.telefonos_contacto.toString() }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:item.start="{ item }">
                        {{ formatDateLarge(item.start) }}
                    </template>
                    <template v-slot:item.isAttended="{ item }">
                        <v-btn v-if="
                            isSelectedComercialActual ||
                            $store.getters[
                                'login/hasAdminPermission'
                            ]
                        " text @click="changeIsAttended(item)">
                            <v-icon class="mr-1" :color="
                                item.isAttended
                                    ? 'green'
                                    : 'red'
                            ">mdi-circle</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <div class="d-flex justify-center">
                            <div class="mr-2" md="3">
                                <v-btn class="d-flex grow justify-center flex-wrap" fab x-small color="primary" outlined
                                    @click="showDialog('View', item.cliente)">
                                    <v-icon> mdi-account </v-icon>
                                </v-btn>
                            </div>
                            <div md="3">
                                <v-btn class="d-flex grow justify-center flex-wrap" fab x-small color="orange" outlined
                                    @click="showDialog('Edit', item.cliente)">
                                    <v-icon> mdi-pen </v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </template>
                </v-data-table>
            </v-window-item>
        </v-window>

        <EditDialog />
        <CopyScheduled />
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import EditDialog from "../../ComercialTeletrabajo/TtForm/CompleteViewTtFormDialog.vue";
import CopyScheduled from "@/components/AreaPersonal/Calendario/CopyScheduled.vue";
import { formatDateLarge } from "@/util/libUtil.js";

export default {
    components: {
        EditDialog,
        CopyScheduled,
    },
    data: () => ({
        footerProps: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [-1],
        },
        isLoadingUpdateAgendado: false,
        estadoComercial: {
            ALTA: "success",
            BAJA: "warning",
            INACTIVO: "error",
            VACACIONES: "blue",
        },
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            timeZone: "Europe/Madrid",
        },
        headers: [
            {
                text: 'Cliente',
                align: 'start',
                sortable: false,
                value: 'name',
            },
            { text: 'Documento',  align: "center", sortable: false, value: 'cliente.documento' },
            {
                text: 'Tlf',
                value: 'cliente.telefonos_contacto',
                sortable: false,
                align: 'center',
            },
            {
                text: 'Operador',
                sortable: false,
                value: 'cliente.isp_actual',
            },
            { text: 'Segmento', value: 'cliente.segmento', sortable: false },
            {
                text: "Fecha agendado",
                align: "center",
                sortable: false,
                value: "start",
            },
            {
                text: 'Acciones',
                sortable: false,
                align: 'center',
                value: 'Actions',
                width: '150px',
            },
            {
                text: "Atendido",
                align: "center",
                sortable: false,
                value: "isAttended",
            }
        ],
        focus: "",
        type: "month",
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        selectedDay: false,
        events: [],
        colors: [
            "blue",
            "indigo",
            "deep-purple",
            "cyan",
            "green",
            "orange",
            "grey darken-1",
        ],
        isLoading: false,
    }),
    mounted() {
        // console.log('calendar');
        // console.log(this.$refs.calendar);
        this.$refs.calendar.checkChange();
    },
    created() {
        this.$store.dispatch("teletrabajo/fetchComerciales").then(() => {
            if (!this.selectedComercial) {
                this.selectedComercial = this.comerciales.find(
                    ({ id }) => id == this.cuenta.id
                );
            }
        });
    },
    computed: {
        isSelectedComercialActual() {
            return this.selectedComercial?.id == this.cuenta.id;
        },
        cuenta() {
            return JSON.parse(localStorage.getItem("cuenta"));
        },
        ...mapState("teletrabajo", {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState("areaPersonal/calendario", {
            agendados: (state) => state.agendados,
            selectedComercial: (state) => state.selectedComercial,
            rangoDate: (state) => state.rangoDate,
        }),
        // ...mapState('login', {
        //     cuenta: (state) => state.cuenta,
        // }),
        selectedComercial: {
            get() {
                return this.selectedComercial;
            },
            set(newValue) {
                return this.$store.commit(
                    "areaPersonal/calendario/selectedComercial",
                    newValue
                );
            },
        },
        requestedAgendados: {
            get() {
                this.$store.state.areaPersonal.calendario.requestedAgendados;
            },
            set(val) {
                this.$store.commit(
                    "areaPersonal/calendario/requestedAgendados",
                    val
                );
            },
        },
        selectedComercial: {
            get() {
                return this.$store.state.areaPersonal.calendario
                    .selectedComercial;
            },
            set(val) {
                this.$store.commit(
                    "areaPersonal/calendario/selectedComercial",
                    val
                );
            },
        },
        rangoDate: {
            get() {
                return this.$store.state.areaPersonal.calendario.rangoDate;
            },
            set(val) {
                this.$store.commit("areaPersonal/calendario/rangoDate", val);
            },
        },
        ...mapGetters('login', {
            hasAdminPermission: 'hasAdminPermission',
        }),
    },
    watch: {
        agendados() {
            const events = [];
            this.agendados.forEach((agendado) => {
                events.push({
                    name: agendado.cliente.nombre,
                    details: agendado.notas,
                    cliente: agendado.cliente,
                    start: new Date(agendado.servicio.fecha_agendado),
                    end: new Date(agendado.servicio.fecha_agendado),
                    isAttended: agendado.servicio.is_attended,
                    idAgendado: agendado.servicio.id,
                    color: this.getColor(agendado.servicio.fecha_agendado),
                    // Fix temporal de timed
                    timed:
                        new Intl.DateTimeFormat("es-ES", this.options)
                            .format(new Date(agendado.servicio.fecha_agendado))
                            .split(" ")[1] == "1:00:00" ||
                        new Intl.DateTimeFormat("es-ES", this.options)
                            .format(new Date(agendado.servicio.fecha_agendado))
                            .split(" ")[1] == "2:00:00" ||
                        new Intl.DateTimeFormat("es-ES", this.options)
                            .format(new Date(agendado.servicio.fecha_agendado))
                            .split(" ")[1] == "0:00:00"
                            ? false
                            : true,
                });
            });
            // sort events by start time
            events.sort((a, b) => {
                return a.start - b.start;
            });
            this.events = events;
        },
        selectedComercial: {
            handler(newValue) {
                if (newValue && !this.hasAdminPermission) {
                    console.log("he entrado", newValue.id);
                    if (newValue.id == this.cuenta.id) {
                        console.log("es igual que el de la cuenta");
                        if (!this.headers.some(({ value }) => value == "isAttended")) {
                            this.headers.push({
                                text: "Atendido",
                                align: "center",
                                sortable: false,
                                value: "isAttended",
                            });
                        }
                    } else {
                        if (this.headers.some(({ value }) => value == "isAttended")) {
                            const index = this.headers.findIndex(({ value }) => value == "isAttended");
                            this.headers.splice(index, 1);
                        }
                    }
                }

                this.isLoading = true;
                setTimeout(() => {
                    this.fetchAgendados(this.rangoDate).then(() => {
                        this.isLoading = false;
                    });
                }, 200);
            },
            immediate: true,
        },
    },
    methods: {
        formatDateLarge,
        ...mapActions("areaPersonal/calendario", [
            "fetchAgendados",
            "updateAgendado",
        ]),
        showDialog(action, cliente) {
            if (action == 'Edit')
                this.$store.dispatch('teletrabajo/editTtForm', cliente);
            else this.$store.dispatch('teletrabajo/viewTtForm', cliente);
        },
        fixDate(date) {
            return `${new Date(date).toLocaleString('es', {
                day: 'numeric',
                month: 'long',
            })}`;
        },
        changeIsAttended(event) {
            this.isLoadingUpdateAgendado = true;
            this.updateAgendado({
                id: event.idAgendado,
                data: {
                    is_attended: !event.isAttended,
                },
            }).then((data) => {
                this.events.find(
                    ({ idAgendado }) => idAgendado == event.idAgendado
                ).isAttended = data.isAttended;
                this.isLoadingUpdateAgendado = false;
            });
        },
        openMoveScheduled() {
            this.$store.commit("areaPersonal/calendario/isOpenMove", true);
        },
        viewDay({ date }) {
            this.focus = date;
            this.type = "day";
            this.selectedDay = true;
        },
        viewMonth() {
            this.type = "month";
            this.selectedDay = false;
        },
        getEventColor(event) {
            return event.color;
        },
        setToday() {
            this.focus = "";
        },
        prevMonth() {
            this.$refs.calendar.prev();
        },
        nextMonth() {
            this.$refs.calendar.next();
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event;
                this.selectedElement = nativeEvent.target;
                requestAnimationFrame(() =>
                    requestAnimationFrame(() => (this.selectedOpen = true))
                );
            };

            if (this.selectedOpen) {
                this.selectedOpen = false;
                requestAnimationFrame(() =>
                    requestAnimationFrame(() => open())
                );
            } else {
                open();
            }

            nativeEvent.stopPropagation();
        },
        showEditDialog(cliente) {
            console.log("selectedEvent");
            console.log(this.selectedEvent);
            this.$store.dispatch("teletrabajo/editTtForm", cliente);
        },
        setAgendados({ start, end }) {
            this.rangoDate = { start, end };
            this.isLoading = true;
            setTimeout(() => {
                this.fetchAgendados({ start, end }).then(() => {
                    this.isLoading = false;
                });
            }, 500);
        },
        getColor(fecha) {
            let current_fecha = new Date(fecha.toString());

            let now = new Date();

            let nextWeek = new Date();
            nextWeek.setDate(nextWeek.getDate() + 7);

            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);

            return this.compareDate(current_fecha, now)
                ? "red"
                : current_fecha < yesterday
                ? "purple"
                : this.compareDate(current_fecha, tomorrow)
                ? "orange"
                : current_fecha < nextWeek
                ? "yellow darken-1"
                : "green";
        },
        compareDate(date1, date2) {
            if (
                date1.getDate() == date2.getDate() &&
                date1.getMonth() == date2.getMonth() &&
                date1.getFullYear() == date2.getFullYear()
            )
                return true;
            else return false;
        },
    },
};
</script>